import axios from 'axios';
import Util from '../Util'

class ReportAPI {

    constructor() {
        this.apiHost = process.env.VUE_APP_API_HOST;
    }

    getEntry(entryId){
     
        let path = "/api/reports/" + entryId;

        let endpoint =  Util.combineUrl(this.apiHost, Util.buildApiPath(path));

        return axios.get(endpoint).then(response => Util.addSnakeCaseAliasesDeep(Util.toCamelCaseDeep(response.data)))
    }

}

let _api = new ReportAPI();

export default _api;